import { render, staticRenderFns } from "./createProjectCategory.vue?vue&type=template&id=084f3b88&scoped=true&"
import script from "./createProjectCategory.vue?vue&type=script&lang=js&"
export * from "./createProjectCategory.vue?vue&type=script&lang=js&"
import style0 from "./createProjectCategory.vue?vue&type=style&index=0&id=084f3b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084f3b88",
  null
  
)

export default component.exports